<div class="mb-0 d-flex align-items-center w-100">
  <label for="excelFile" class="btn btn-success d-flex align-items-center justify-content-center gap-2 mb-0 w-100"
    style="white-space: nowrap;">
    <i class="bi bi-cloud-arrow-up"></i>
    <span>Choose File to Upload</span>
  </label>

  <input id="excelFile" type="file" class="d-none" [attr.accept]="accept" (change)="onFileChange($event)" />
</div>

@if (showModal) {
<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true"
  style="background-color: rgba(0, 0, 0, 0.5); z-index: 999999; position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-dark" [ngClass]="{
        'border-success': modalType === 'success',
        'border-danger': modalType === 'error',
        'border-primary': modalType === 'confirm'
      }">
      <div class="modal-header">
        <h5 class="modal-title">
          @if (modalType === 'success') {
          <i class="bi bi-check-circle-fill text-success me-2"></i>Success
          }
          @if (modalType === 'error') {
          <i class="bi bi-x-circle-fill text-danger me-2"></i>Error
          }
          @if (modalType === 'confirm') {
          <i class="bi bi-question-circle-fill text-success me-2"></i>Confirm
          Upload
          }
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closePopup()"></button>
      </div>
      <div class="modal-body text-dark">
        {{ message }}
      </div>
      <div class="modal-footer">
        @if (modalType === 'confirm') {
        <button type="button" class="btn btn-secondary" (click)="closePopup()">
          Cancel
        </button>
        <button type="button" class="btn btn-success" (click)="confirmUpload()">
          Confirm
        </button>
        } @else {
        <button type="button" class="btn btn-primary" (click)="closePopup()">
          OK
        </button>
        }
      </div>
    </div>
  </div>
</div>
}